import { ViewType } from "../assets/constants";
import { matchPath, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ROUTES from "../assets/routes";
import { selectFinancialPanelOpen, selectSeasonalsPanelOpen } from "../selectors/home";


export const getViewFromPathname = (pathname: string): ViewType | null => {
    if (matchPath(ROUTES.chart, pathname)) return ViewType.CHART
    if (matchPath(ROUTES.shareholderHoldings, pathname)) return ViewType.SHAREHOLDER_HOLDINGS_DATA
    if (matchPath(ROUTES.optionChain, pathname)) return ViewType.OPTION_CHAIN
    if (matchPath(ROUTES.openInterestChange, pathname)) return ViewType.OPEN_INTEREST_CHANGE
    if (matchPath(ROUTES.openInterest, pathname)) return ViewType.OPEN_INTEREST
    if (matchPath(ROUTES.multiStrikeChart, pathname)) return ViewType.MULTI_STRIKES_CHART
    if(matchPath(ROUTES.strategyBuilder, pathname)) return ViewType.STRATEGY_BUILDER
    if(matchPath(ROUTES.simulator, pathname)) return ViewType.SIMULATOR
    if(matchPath(ROUTES.reports, pathname)) return ViewType.REPORTS
    if (matchPath(ROUTES.symbol, pathname)) return ViewType.SYMBOL
    if (matchPath(ROUTES.spread, pathname)) return ViewType.SPREAD
    return null
}

const useSelectView = (): ViewType | null => {
    const { pathname } = useLocation()
    const financialPanelOpen = useSelector(selectFinancialPanelOpen)
    const seasonalsPanelOpen = useSelector(selectSeasonalsPanelOpen)
    const routeView = getViewFromPathname(pathname)

    const isChartOrSymbol = routeView && [ViewType.CHART, ViewType.SYMBOL].includes(routeView)

    if (financialPanelOpen && isChartOrSymbol) {
        return ViewType.FINANCIAL_DATA
    }

    if (seasonalsPanelOpen && isChartOrSymbol) {
        return ViewType.SEASONALS
    }

    return routeView
}

export default useSelectView
